import React from 'react';
import LogoName from "../assets/getYourToken.jpg";
import {Card, ListGroup} from "react-bootstrap";
import SyntaxHighLighter from "react-syntax-highlighter";
import {dark} from "react-syntax-highlighter/src/styles/hljs";

const GetYourToken = () => {
    return (
        <div className="token-page">
            <div className="token-header">
                <img src={LogoName} alt="logo"/>
                <span>
                    <h3> How to get your JWT token</h3>
                    <p>Please follow the steps below for authenticating and authorizing your application</p>
                </span>
            </div>
            <Card className="card-body">
                <Card.Header><strong>Steps 1-3 </strong></Card.Header>
                <ListGroup variant="flush">
                    <ListGroup.Item>
                        <div className="list-item-container">
                            <span className="step-header">
                                <strong>Step 1 </strong>
                            </span>
                            <span className="step-content">
                                First you need to get your client credentials by contacting <a href="/#">integration@vatit.com</a>
                            </span>
                        </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <div className="list-item-container">
                            <span className="step-header">
                                <strong>Step 2 </strong>
                            </span>
                            <span className="step-content">
                                You need to make a POST HTTP request to <a href="/#">https://developer.vatit.com/oauth2/token</a><br/> Your request should look like this:
                            </span>
                            <SyntaxHighLighter className="rounded-corners" language="javascript" style={dark}>
                                {
                                    "curl -X POST \n -H \"Content-Type: application/x-www-form-urlencoded\" \n -d 'client_id=[we_provide_client_id]&scope=[we_provide_scope]&client_secret=[we_provide_client_secret]&grant_type=client_credentials' \n 'https://developer.vatit.com/oauth2/token'"
                                }
                            </SyntaxHighLighter>
                        </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <div className="list-item-container">
                            <span className="step-header">
                                <strong>Step 3 </strong>
                            </span>
                            <span className="step-content">
                                Once you have your token, when submitting a request to us, ensure that in your HTTP Headers,<br/> you have the following:
                            </span>
                            <SyntaxHighLighter className="rounded-corners" language="javascript" style={dark}>
                                {
                                    "Authorization: Bearer [your token goes here]"
                                }
                            </SyntaxHighLighter>
                        </div>
                    </ListGroup.Item>
                </ListGroup>
            </Card>
        </div>
    )
}

export default GetYourToken;
